'use client'

import { useAtomValue } from 'jotai'
import { type PropsWithChildren, useMemo } from 'react'
import { Banner } from '@/src/components/ui/banner'
import { polarisFeedbackLink } from '@/src/configs/external-links'
import { routeErrorsAtom, swapRequirementsAtom } from '@/src/stores/swap/atoms'

type RoutePreviewErrorsProps = unknown

export function RoutePreviewErrors({
  children,
}: PropsWithChildren<RoutePreviewErrorsProps>) {
  const { enabled } = useAtomValue(swapRequirementsAtom)
  const routeErrors = useAtomValue(routeErrorsAtom)

  const error = useMemo(() => {
    if (enabled) {
      if (routeErrors?.generic) {
        return {
          title: 'Something went wrong',
          description:
            'Please try again later. If the problem continues, you can reach out to Polaris Support.',
        }
      }
    }
    return undefined
  }, [enabled, routeErrors?.generic])

  return error ? (
    <Banner
      className='bg-transparent m-5 border-2 border-border2 rounded-3xl'
      variant='warning'
      alertTitle={error?.title}
      description={error?.description}
      primaryAction={{
        label: 'Contact Support',
        href: polarisFeedbackLink,
      }}
    />
  ) : (
    children
  )
}
